<div class="pageheader">
    <div class="page-title">
        <h1>Monitor schedules</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">
                <span>Refresh</span>
                <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
            <app-change-log-link *bizPermissionRequired="'Monitor_Action_ShowLog'" [title]="'Monitor schedules log'">
                <app-change-log-link-entity type="MonitorSchedule"></app-change-log-link-entity>
                <!-- TODO: Missing ScheduledItems - Not currently supported by ChangeLog as current implementation would display ALL ScheduledItems, not just the ones used by MonitorSchedules -->
            </app-change-log-link>
        </div>
    </div>
</div>

<app-monitor-schedules-grid #grid [monitorSchedules]="monitorSchedules()" (saveGroupMonitorSchedule)="onSaveSchedule($event)" (deleteMonitorSchedule)="onDeleteSchedule($event)">
</app-monitor-schedules-grid>
